import { connect } from "react-redux";

// Component
import Tasks from "./Tasks";

import {
  getOrganizationMembersList,
} from "../Projects/projectsActions";
import { getOfficesShortList } from "../Offices/officesActions";
import {
  getTasksList,
  duplicateTask,
  deleteTask,
  createTask,
  exportTasks,
} from "./tasksActions";

// Store props to map with current state
const mapStateToProps = (state) => ({
  selectedOrganization: state.organization.selectedOrganization,
  orgMembersList: state.project.orgMembersList,
  officesShortList: state.office.officesShortList,
  duplicateIsLoading: state.task.duplicateIsLoading,
  deleteIsLoading: state.task.deleteIsLoading,
  deletedCallback: state.task.deletedCallback,
  tasksList: state.task.tasksList,
  createdTaskInfo: state.task.createdTaskInfo,
  overlap: state.task.overlap,
  duplicateTaskInfo: state.task.duplicateTaskInfo,
  isLoading: state.task.isLoading,
  loadingTaskAssigneeId: state.project.loadingTaskAssigneeId,
  exportLoading: state.task.exportLoading,
  // pagination
  totalTasksCount: state.task.tasksListCount,
  pageSize: state.task.taskListPageSize,
});

// Actions prop to dispatch
const mapDispatchToProps = (dispatch) => ({
  getOrganizationMembersList: (payload) => dispatch(getOrganizationMembersList(payload)),
  getOfficesShortList: (payload) => dispatch(getOfficesShortList(payload)),
  getTasksList: (payload) => dispatch(getTasksList(payload)),
  duplicateTask: (payload) => dispatch(duplicateTask(payload)),
  deleteTask: (payload) => dispatch(deleteTask(payload)),
  createTask: (payload) => dispatch(createTask(payload)),
  exportTasks: (payload) => dispatch(exportTasks(payload)),
});

// connect states and dispatchers with components
export default connect(mapStateToProps, mapDispatchToProps)(Tasks);
